import { graphql } from 'react-relay';
import { getRelayEnvironment } from '@/RelayEnvironment';
import commitMutationPromise from '../../services/commitMutationPromise';
import type {
    AddRecipientsToListMutation as AddRecipientsToListMutationType,
    AddRecipientsToListMutation$data,
} from './__generated__/AddRecipientsToListMutation.graphql';
//import { ConnectionHandler } from 'relay-runtime'
//Debug
//import storeDebugger from 'relay-runtime/lib/RelayStoreProxyDebugger'

export type { AddRecipientsToListMutationType };
export const AddRecipientsToListMutation = graphql`
    mutation AddRecipientsToListMutation(
        $input: AddRecipientsToListInput!
    ) {
        addRecipientsToList(input: $input) {
            recipientList {
                id
                recipientCount
                recipients {
                    type
                    emailAddress
                    phoneNumber
                    respondentId
                    preRegisteredMetaQuestionResponses {
                        questionId: originalQuestionId
                        selectedResponseOptions {
                            value
                        }
                    }
                    metaQuestionResponses {
                        questionId: originalQuestionId
                        isPreRegisteredMeta
                        selectedResponseOptions {
                            value
                        }
                    }
                }
            }
        }
    }
`;

// let tempID = 0;

type AddRecipientsToListMutationProps = {
    recipientListId: string;
    emailAddresses: string[];
    phoneNumbers: string[];
};

export const commitAddRecipientsToListMutation = async ({
    recipientListId,
    emailAddresses = [],
    phoneNumbers = [],
}: AddRecipientsToListMutationProps): Promise<AddRecipientsToListMutation$data> => {
    const variables = {
        input: {
            recipientListId,
            emailAddresses,
            phoneNumbers,
        },
    };

    return await commitMutationPromise<AddRecipientsToListMutationType>(
        getRelayEnvironment(),
        {
            mutation: AddRecipientsToListMutation,
            variables,
        },
    );
};
